import React, { useRef } from 'react';

import ModalPhotoBase from './ModalPhotoBase';

import PhotoBg from '../../../../../Images/modals/photographers/mario/bg_mario.png';
import Photo1 from '../../../../../Images/modals/photographers/mario/photo-1.png';
import Photo2 from '../../../../../Images/modals/photographers/mario/photo-2.png';
import Photo3 from '../../../../../Images/modals/photographers/mario/photo-3.png';

import {
  Photo_Mario,
  Text_Mario,
  TextPhoto1_Mario,
  TextPhoto2_Mario,
  TextPhoto3_Mario,
} from '../../../../../utils/ES/Modals/photographers';

const ModalMario = () => {
  return (
    <>
      <ModalPhotoBase
        id="photo-mario"
        mainBg={PhotoBg}
        directorName={Photo_Mario}
        mainVideoBg={Photo1}
        videoText1={TextPhoto1_Mario}
        directorText={Text_Mario}
        rowImage1={Photo2}
        videoText2={TextPhoto2_Mario}
        rowWidth1={'339px'}
        rowImage2={Photo3}
        videoText3={TextPhoto3_Mario}
        rowWidth2={'339px'}
        rowWidth3={'0px'}
        mainGallery={'mario-gallery-3'}
        gallery2={'mario-gallery-2'}
        gallery3={'mario-gallery-1'}
      />
    </>
  );
};

export default ModalMario;
